var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.newVersion)?_c('a',{staticClass:"queue-notif",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.reloadApp($event)}}},[_vm._v(" nouvelle version disponible ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }